import { StationNotificationApi } from '@common/ApiService'
import { updateField } from '@state/helpers'
import roundTime from '@utils/round-time'
const STATION_NOTIFICATIONS_SUCCESS = 'STATION_NOTIFICATIONS_SUCCESS'
const STATION_NOTIFICATION_ERROR = 'STATION_NOTIFICATION_ERROR'
const STATION_NOTIFICATION_SUCCESS = 'STATION_NOTIFICATION_SUCCESS'
const UPDATE_STATION_ID = 'UPDATE_STATION_ID'
const CLEAR_STATION_NOTIFICATION = 'CLEAR_STATION_NOTIFICATION'

const initialActiveFrom = (delay) => {
  const date = new Date()
  date.setDate(date.getDate() + delay)
  date.setHours(0, 0, 0, 0)
  return date
}

export const state = {
  station_notifications: [],
  station_notification: {
    active_from: roundTime(initialActiveFrom(0)),
    active_to: roundTime(initialActiveFrom(1)),
    body: '',
    contact_info: '',
    station_id: '',
  },
  errors: {},
}

export const getters = {}

export const mutations = {
  updateField,

  [STATION_NOTIFICATIONS_SUCCESS](state, data) {
    state.station_notifications = data
    return state
  },

  [STATION_NOTIFICATION_SUCCESS](state, data) {
    state.station_notification = data
    return state
  },

  [STATION_NOTIFICATION_ERROR](state, data) {
    state.errors = data
    state.progress = 'error'
    return state
  },

  [CLEAR_STATION_NOTIFICATION](state) {
    state.station_notification = {
      active_from: roundTime(new Date()),
      active_to: roundTime(new Date()),
      body: '',
      contact_info: '',
      station_id: '',
    }
    return state
  },

  [UPDATE_STATION_ID](state, id) {
    state.station_notification.station_id = id
    return state
  },
}

export const actions = {
  createStationNotification({ commit }, notification) {
    return StationNotificationApi.post({ ...notification }).then((response) => {
      commit(CLEAR_STATION_NOTIFICATION, response.data)
    })
  },

  setStationId({ commit }, id) {
    commit(UPDATE_STATION_ID, id)
  },

  fetchStationNotifications({ commit }, query) {
    return StationNotificationApi.query({
      params: {
        station_code: query,
      },
    })
      .then((response) => {
        commit(STATION_NOTIFICATIONS_SUCCESS, response.data)
      })
      .catch((error) => commit(STATION_NOTIFICATION_ERROR, error))
  },

  destroyNotification({ commit }, notificationId) {
    return StationNotificationApi.destroy(notificationId).catch((error) =>
      commit(STATION_NOTIFICATION_ERROR, error)
    )
  },
}
